import React from 'react';
import {
  Body,
  Button,
  designSystemToken,
  Icon,
  Label,
} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import styles from './FilterButton.module.scss';

type FilterButtonProps = {
  testID?: string;
  onClick: () => void;
  activeFilterCount?: number;
};

function FilterButton({
  testID = 'filter-button',
  onClick,
  activeFilterCount = 0,
}: FilterButtonProps) {
  return (
    <Button
      data-testid={testID}
      variant="text"
      size="small"
      startIcon={
        <Icon
          size="small"
          appearance="neutral"
          name="Actions-Filter-Funnel"
          color={designSystemToken('semantic.fg.secondary')}
          style={{width: '18px', height: '18px'}}
        />
      }
      endIcon={
        activeFilterCount ? (
          <div className={styles.filterCountWrapper}>
            <Label size="sm" className={styles.filterCountBadge}>
              {activeFilterCount}
            </Label>
          </div>
        ) : null
      }
      onClick={onClick}
    >
      <Body size="sm" color={designSystemToken('semantic.fg.primary')}>
        {translate('Filters')}
      </Body>
    </Button>
  );
}

export default FilterButton;
